var map = {
	"./br/drag-to-answer-white.png": "./src/assets/img/localization/br/drag-to-answer-white.png",
	"./de/drag-to-answer-white.png": "./src/assets/img/localization/de/drag-to-answer-white.png",
	"./el/drag-to-answer-white.png": "./src/assets/img/localization/el/drag-to-answer-white.png",
	"./en/drag-to-answer-white.png": "./src/assets/img/localization/en/drag-to-answer-white.png",
	"./es/drag-to-answer-white.png": "./src/assets/img/localization/es/drag-to-answer-white.png",
	"./it/drag-to-answer-white.png": "./src/assets/img/localization/it/drag-to-answer-white.png",
	"./ko/drag-to-answer-white.png": "./src/assets/img/localization/ko/drag-to-answer-white.png",
	"./ru/drag-to-answer-white.png": "./src/assets/img/localization/ru/drag-to-answer-white.png",
	"./sl/drag-to-answer-white.png": "./src/assets/img/localization/sl/drag-to-answer-white.png",
	"./tr/drag-to-answer-white.png": "./src/assets/img/localization/tr/drag-to-answer-white.png",
	"./us/drag-to-answer-white.png": "./src/assets/img/localization/us/drag-to-answer-white.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/localization sync recursive ^\\.\\/.*\\/drag\\-to\\-answer\\-white\\.png$";